import GainLossListsScreenAPI from "../services/gainloss-lists-screen-service";
import { observable } from "mobx";
import { AppConstants } from "../../../common/APIConstants";
import moment from "moment";
import RestEndPoint from "../../../common/RestEndPoint";

class GainLossListsScreenStore {
  @observable entityData = [];
  @observable entityTypes = [];
  @observable selectedJurisdiction = null;
  @observable selectedEntityType = null;
  @observable addButtonText = "Add";
  @observable exportButtonText = "Export";

  setSelectedJurisdiction = (jurisdiction) =>
    (this.selectedJurisdiction = jurisdiction);
  setSelectedEntityType = (entityType) =>
    (this.selectedEntityType = entityType);
  setEntityData = (entityData) => (this.entityData = entityData);

  getEntityTypes = async () => {
    try {
      const response = await GainLossListsScreenAPI.getEntityTypes();

      this.entityTypes = response?.data?.map((item) => ({
        label: item,
        value: item,
      }));
    } catch (error) {
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  getEntityData = async (
    CommonStore,
    jurisdiction = this.selectedJurisdiction,
    entityType = this.selectedEntityType
  ) => {
    if (!entityType || !jurisdiction) return;
    CommonStore.toggleLoader();
    try {
      const requestData = {
        jurisdiction: jurisdiction?.value,
        entityType: entityType?.value,
      };
      const response = await GainLossListsScreenAPI.getEntityList(requestData);
      const entityData = response?.data?.map((item) => ({
        ...item,
        isActive: item.isActive ? "Active" : "Inactive",
      }));
      this.entityData = entityData;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  createEntity = async (data, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      const requestData = {
        ...data,
        createdBy: RestEndPoint.getCurrentUserName(),
        createdDate: new Date().toLocaleString(
          "en-US",
          { hour12: false },
          {
            timeZone: "America/Denver",
            timeZoneName: "short",
          }
        ),
      };

      await GainLossListsScreenAPI.createEntity(requestData);
      await this.getEntityData(
        CommonStore,
        this.selectedJurisdiction,
        this.selectedEntityType
      );
      CommonStore.toggleLoader();
      window.toastr.success(
        AppConstants.GAIN_LOSS.LISTS_SCREEN.TOAST_MESSAGES.CREATE_SUCCESS
      );
    } catch (error) {
      await this.getEntityData(
        CommonStore,
        this.selectedJurisdiction,
        this.selectedEntityType
      );
      CommonStore.toggleLoader();
      if (error.response.data.includes("Violation of UNIQUE KEY constraint")) {
        window.toastr.error(
          AppConstants.GAIN_LOSS.LISTS_SCREEN.TOAST_MESSAGES
            .CREATE_DUPLICATE_ERROR
        );
      } else {
        window.toastr.error(
          AppConstants.GAIN_LOSS.LISTS_SCREEN.TOAST_MESSAGES
            .CREATE_GENERIC_ERROR
        );
      }
    }
  };

  updateEntity = async (data, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      const requestData = {
        ...data,
        isActive: data?.isActive === "Active",
        updatedBy: RestEndPoint.getCurrentUserName(),
        updatedDate: new Date().toLocaleString(
          "en-US",
          { hour12: false },
          {
            timeZone: "America/Denver",
            timeZoneName: "short",
          }
        ),
      };

      await GainLossListsScreenAPI.updateEntity(data?.listId, requestData);

      await this.getEntityData(
        CommonStore,
        this.selectedJurisdiction,
        this.selectedEntityType
      );
      CommonStore.toggleLoader();
      window.toastr.success(
        AppConstants.GAIN_LOSS.LISTS_SCREEN.TOAST_MESSAGES.UPDATE_SUCCESS
      );
    } catch (error) {
      await this.getEntityData(
        CommonStore,
        this.selectedJurisdiction,
        this.selectedEntityType
      );
      CommonStore.toggleLoader();
      if (error.response.data.includes("Violation of UNIQUE KEY constraint")) {
        window.toastr.error(
          AppConstants.GAIN_LOSS.LISTS_SCREEN.TOAST_MESSAGES
            .UPDATE_DUPLICATE_ERROR
        );
      } else {
        window.toastr.error(
          AppConstants.GAIN_LOSS.LISTS_SCREEN.TOAST_MESSAGES
            .UPDATE_GENERIC_ERROR
        );
      }
    }
  };
}

export default new GainLossListsScreenStore();
